import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  padding: ${space[4]} 0;
  border-top: 1px solid ${semantic.border.subtle};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LabelText = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const Content = styled.div`
  padding-top: ${space[4]};
`;
